import script from "./view-guide.vue?vue&type=script&setup=true&lang=js"
export * from "./view-guide.vue?vue&type=script&setup=true&lang=js"

import "./view-guide.vue?vue&type=style&index=0&id=1c3b6eb2&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3b6eb2"]])

export default __exports__